import { Target, Users, LineChart, Zap, Shield, MessageSquare } from 'lucide-react';

export const featureData = [
  {
    icon: Target,
    benefitHeadline: "Feedback That Drives Results",
    benefitBody: "Gain actionable insights from a feedback process customized to your unique career aspirations, helping you focus on what matters most.",
    featureHeadline: "Specialized Questionnaires for Every Goal",
    featureBody: "Choose from tailored questionnaires aligned to different career growth objectives, ensuring feedback that's relevant to your path."
  },
  {
    icon: Users,
    benefitHeadline: "See Yourself Through Every Lens",
    benefitBody: "Understand how others perceive your strengths and growth areas, empowering you to build credibility and collaboration across teams.",
    featureHeadline: "Comprehensive Feedback from Key Stakeholders",
    featureBody: "Collect insights from peers, managers, and stakeholders for a complete and well-rounded understanding of your professional impact."
  },
  {
    icon: LineChart,
    benefitHeadline: "Turn Data into Career Progress",
    benefitBody: "Use meaningful metrics to stay focused, measure improvement, and identify opportunities for continuous growth.",
    featureHeadline: "Data-Driven Performance Tracking",
    featureBody: "Monitor your career progress over time with detailed analytics that highlight strengths, challenges, and trends."
  },
  {
    icon: Zap,
    benefitHeadline: "Clear Steps to Unlock Your Potential",
    benefitBody: "Transform insights into progress with guided recommendations that make career advancement actionable and achievable.",
    featureHeadline: "Personalized Roadmaps to Success",
    featureBody: "Receive AI-crafted action plans with step-by-step recommendations tailored to your feedback and career goals."
  },
  {
    icon: Shield,
    benefitHeadline: "Safe Spaces for Honest Growth",
    benefitBody: "Build trust and get the feedback you need without fear of judgment, creating the foundation for genuine professional development.",
    featureHeadline: "Secure and Anonymous Feedback System",
    featureBody: "Foster honest responses with a system designed to protect anonymity and encourage candid insights."
  },
  {
    icon: MessageSquare,
    benefitHeadline: "Make Sense of What Matters",
    benefitBody: "Turn raw feedback into clarity with tools that distill context and key takeaways, enabling you to take meaningful next steps.",
    featureHeadline: "AI-Powered Contextual Feedback Analysis",
    featureBody: "Decode complex feedback with AI-amplified analysis, offering nuanced insights and actionable highlights."
  }
];